import { gql, TypedDocumentNode } from '@common/hooks';
import {
  UnassignShiftMutationCgResponse,
  UnassignShiftMutationVariables,
} from '@common/graphql';

// Manually removes a worker from a filled shift on a reviewable run (WORK-6384),
// including an engine-suggested cell. Addressed by the shift uuid. Returns the removed
// shift's uuid so the caller can refetch the recompute-on-read grid / candidates / health.
export const UNASSIGN_SHIFT_MUTATION: TypedDocumentNode<
  UnassignShiftMutationCgResponse,
  UnassignShiftMutationVariables
> = gql`
  mutation UnassignShift(
    $balancerRunId: ID!
    $organizationUnitId: ID!
    $shiftId: ID!
  ) {
    unassignShift(
      balancerRunId: $balancerRunId
      organizationUnitId: $organizationUnitId
      shiftId: $shiftId
    ) {
      affectedShiftId
      balancerRunId
      state
    }
  }
`;
